















import { tns } from "tiny-slider/src/tiny-slider";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
    components: {
        ProjectCard: () => import("../project/card.vue")
    }
})
export default class Projects extends Vue {
    loading: boolean = false;

    projects: Estate[] = [];

    private mounted() {
        this.getProjects();
    }

    private getProjects() {
        this.loading = true;
        // @ts-ignore
        axios
            .get("/api/projects")
            .then((response: any) => (this.projects = response.data.data))
            .finally(() => (this.loading = false));
    }
}
